import React from 'react';
import './TermsPage.css';
import backgroundImg from '../assets/background.png';

const termsText = `**TERMOS E CONDIÇÕES GERAIS DE USO DA PLATAFORMA FUT+**
**Última atualização: 17/03/2026**

Bem-vindo(a) ao Fut+!

Este documento estabelece os Termos e Condições de Uso ("Termos") que regem o acesso e a utilização da plataforma web e mobile do Fut+, de titularidade de **Alisson Sorgatto Moreira Frank**, inscrito no CPF sob o nº **063.369.101-13**, com sede em **Cuiabá - MT**, desenvolvida sob o nome fantasia **Fut+ Dev Solo**.

Ao acessar, se cadastrar ou utilizar a Plataforma Fut+, você (doravante "Usuário") declara ter lido, compreendido e aceitado expressa e integralmente todas as disposições destes Termos. Caso não concorde com qualquer disposição, você não deverá utilizar a Plataforma.

---

### 1. DEFINIÇÕES

Para fins destes Termos, aplicam-se as seguintes definições:

Plataforma: O software Fut+, acessível via web e aplicativo mobile, destinado à gestão de campeonatos esportivos amadores.

Organizador / Gestor: Usuário responsável por criar, configurar e gerenciar um campeonato, estipular regras e definir taxas de inscrição.

Diretor / Técnico: Usuário responsável por criar e gerenciar um Time, bem como convidar e inscrever Jogadores.

Jogador / Atleta: Usuário inscrito em um ou mais times, detentor de um perfil próprio e de uma Carteirinha Digital.

Carteirinha Digital: Documento virtual gerado pela Plataforma após a confirmação de inscrição e pagamento, utilizado para identificação do Jogador nos jogos.

---

### 2. OBJETO

O Fut+ é um software como serviço (SaaS) que fornece ferramentas tecnológicas para a organização de campeonatos esportivos amadores. A Plataforma permite a criação de tabelas, controle de estatísticas (gols, cartões, histórico), emissão de carteirinhas digitais, vitrine de jogadores ("Mercado da Bola") e intermediação de pagamentos de taxas de inscrição.

O Fut+ não é organizador de eventos esportivos. Nossa responsabilidade limita-se ao fornecimento da tecnologia. Não nos responsabilizamos por lesões, cancelamentos de jogos, disputas entre times, não pagamento de premiações ou qualquer ocorrência física nos eventos cadastrados.

---

### 3. CADASTRO E CONTA DE USUÁRIO

3.1. Para utilizar as funcionalidades da Plataforma, o Usuário deve fornecer dados exatos, precisos e verdadeiros, incluindo, mas não se limitando a: Nome Completo, CPF, Data de Nascimento e E-mail.

3.2. O uso do CPF é obrigatório para garantir a unicidade do Jogador, evitando fraudes e duplicação de estatísticas e inscrições.

3.3. A criação de perfis falsos (falsidade ideológica) ou o uso de CPF de terceiros sem autorização é crime e resultará no banimento imediato da Plataforma, além das sanções legais cabíveis.

3.4. O Usuário é o único responsável pela guarda e sigilo de sua senha de acesso.

---

### 4. PAGAMENTOS, TAXAS E ASSINATURAS (VIA ASAAS)

4.1. O Fut+ utiliza a processadora de pagamentos Asaas para gerenciar cobranças (Pix, Cartão de Crédito ou Boleto) referentes a taxas de inscrições de times, atletas ou assinaturas de uso da plataforma.

4.2. Taxas de Campeonato: Os valores cobrados para inscrição de times ou emissão de carteirinhas de jogadores são definidos exclusivamente pelo Organizador do campeonato. O Fut+ atua apenas como facilitador do recebimento.

4.3. O processamento dos pagamentos está sujeito aos Termos de Uso da própria processadora (Asaas). O Fut+ não armazena dados de cartão de crédito em seus servidores.

4.4. Inadimplência: A ausência de confirmação de pagamento impedirá a geração da Carteirinha Digital do jogador e sua participação no campeonato.

---

### 5. DIREITO DE ARREPENDIMENTO E CANCELAMENTOS

5.1. Nos termos do Art. 49 do Código de Defesa do Consumidor (CDC), o Usuário que realizar a compra de uma assinatura da plataforma ou pagar uma taxa de inscrição tem o direito de se arrepender em até 7 (sete) dias corridos após a transação.

5.2. Exceção: O reembolso da taxa de inscrição de um campeonato não será efetuado caso o Jogador ou Time já tenha usufruído do serviço (por exemplo: se o Jogador já participou de uma partida oficial utilizando a Carteirinha Digital gerada), caracterizando a prestação e consumo do serviço.

5.3. Solicitações de cancelamento e reembolso devem ser feitas através do e-mail de suporte da Plataforma.

---

### 6. DIREITOS DE IMAGEM E CARTEIRINHA DIGITAL

6.1. Ao fazer o upload de uma foto de perfil, o Jogador concede ao Fut+ o direito de exibir essa imagem publicamente na Plataforma (nas escalações, artilharia e súmulas) e na sua Carteirinha Digital.

6.2. Organizadores e Usuários podem fazer upload de fotos e vídeos (Mídia) dos jogos. Ao fazer o upload, o Usuário declara ter o direito de uso daquelas imagens e isenta o Fut+ de qualquer infração de direitos de imagem de terceiros.

6.3. O Usuário pode solicitar a exclusão de sua foto de perfil a qualquer momento através do painel da sua conta.

---

### 7. MERCADO DA BOLA E CONDUTA DO USUÁRIO

7.1. A Plataforma oferece o "Mercado da Bola", um espaço onde jogadores sem time podem se anunciar. O Fut+ não tem envolvimento, responsabilidade ou comissionamento sobre contratações ou acordos feitos entre Diretores e Jogadores fora da Plataforma.

7.2. É terminantemente proibido utilizar a Plataforma para:

* Propagar discursos de ódio, racismo, homofobia ou qualquer tipo de discriminação
* Fazer upload de conteúdo pornográfico, violento ou protegido por direitos autorais
* Tentar burlar o sistema de pagamentos ou alterar estatísticas de má-fé

7.3. O Fut+ reserva-se o direito de excluir conteúdos e banir Usuários que violem estas regras, sem aviso prévio.

---

### 8. PRIVACIDADE E PROTEÇÃO DE DADOS (LGPD)

8.1. O Fut+ coleta e processa dados pessoais estritamente necessários para a prestação dos serviços.

8.2. Ao utilizar a Plataforma, você consente com o tratamento de seus dados conforme descrito.

8.3. Os dados estatísticos são de caráter público dentro da plataforma.

8.4. O Usuário pode solicitar exclusão de dados via suporte, respeitando o histórico esportivo.

---

### 9. DISPONIBILIDADE DA PLATAFORMA E LIMITAÇÃO DE RESPONSABILIDADE

9.1. O Fut+ emprega esforços para manter a Plataforma disponível 24h.

9.2. Não nos responsabilizamos por indisponibilidades ou problemas externos.

---

### 10. ALTERAÇÕES NOS TERMOS

O Fut+ poderá alterar estes Termos a qualquer momento. O uso contínuo da plataforma implica aceitação das alterações.

---

### 11. ATENDIMENTO E SUPORTE

E-mail: tvplay544@gmail.com
WhatsApp: (66) 99259-3031

---

### 12. FORO E LEGISLAÇÃO APLICÁVEL

Fica eleito o foro da comarca de Cuiabá - MT, com base nas leis brasileiras.
`;

const TermsPage = () => {
  return (
    <div 
      className="terms-page"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="terms-page-container">
        <div className="terms-page-header">
          <h1>Termos de Uso</h1>
        </div>
        <div className="terms-page-content">
          <pre className="terms-page-text">{termsText}</pre>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;